import {Injectable} from '@angular/core';
import {CrudService} from '../crud/crud.service';
import {Spring} from '../spring/spring';
import * as CryptoJS from 'crypto-js';
import {formatCurrency, getCurrencySymbol} from '@angular/common';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import {HttpResponse} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UtileriasService {
  private key = 'YSqOpt7rr8LlIHGBkDC9';

  constructor(private crud: CrudService,
              private spring: Spring) {
  }


  encrypt(txt: string): string {
    return CryptoJS.AES.encrypt(txt, this.key).toString();
  }

  decrypt(txtToDecrypt: string) {
    if (txtToDecrypt !== null) {
      return CryptoJS.AES.decrypt(txtToDecrypt, this.key).toString(CryptoJS.enc.Utf8);
    } else {
      return null;
    }

  }

  getFechaActual() {
    return this.crud.get(`${this.spring.UTILERIAS_CURDATE}`);
  }

  validarRFC(rfc: string) {
    return this.crud.getText(`${this.spring.PSPERSON_VALIDAR_RFC}${rfc}`)
  }

  validarRFCProveedor(rfc: string) {
    return this.crud.getText(`${this.spring.PVPROVEE_VALIDAR_RFC}${rfc}`)
  }


  formatDate(date) {
    const year = date.getFullYear().toString();
    const month = (date.getMonth() + 101).toString().substring(1);
    const day = (date.getDate() + 100).toString().substring(1);
    return year + '-' + month + '-' + day;
  }

  primerDiaMesActual() {
    const fecha = new Date();
    const primerDia = new Date(fecha.getFullYear(), fecha.getMonth(), 1);
    return this.formatDate(primerDia);
  }

  diaActual() {
    return this.formatDate(new Date());
  }

  getCurrency(value: string) {
    let val = parseInt(value, 10);
    if (Number.isNaN(val)) {
      val = 0;
    }
    return formatCurrency(val, 'es-MX', getCurrencySymbol('', 'narrow'));
  }

  public getGoogleMaps(direccion: string): void {
    const url = 'https://www.google.com/maps/search/?q=' + encodeURIComponent(direccion);
    window.open(url, '_blank');
  }

  public getDiferenciaMeses(fecha1: Date, fecha2: Date): number {
    return (fecha2.getFullYear() - fecha1.getFullYear()) * 12 + (fecha2.getMonth() - fecha1.getMonth());
  }


  checkParamsUrl(router: Router): void {
    const url = router.parseUrl(router.url);
    const returnUrl = url.queryParams['returnUrl'];
    const id = url.queryParams['id'];
    if (returnUrl != undefined && returnUrl != null) {
      const urlModule = {
        value: returnUrl,
        id: id
      }
      sessionStorage.setItem('url', JSON.stringify(urlModule));
    }
  }

  getValueUrlParams(router: Router): string {
    const url = router.url;
    const modulo = url.split('/')[1];

    const urlStorage = JSON.parse(sessionStorage.getItem('url'));
    if (urlStorage != undefined && urlStorage != null) {
      if (urlStorage.value.split('/')[0] == modulo) {
        return urlStorage.id;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  resetUrlParams(): void {
    sessionStorage.removeItem('url');
  }

  getFotoUsuario(): Observable<HttpResponse<string>> {
    return this.crud.getText(`${this.spring.USUSUARI_GET_AVATAR}`);
  }


  formatCurrencyLabel(value: number): string {
    if (value >= 1_000_000_000) {
      return `$${(value / 1_000_000_000).toFixed(1)}B`;
    } else if (value >= 1_000_000) {
      return `$${(value / 1_000_000).toFixed(1)}M`;
    } else if (value >= 1_000) {
      return `$${(value / 1_000).toFixed(1)}K`;
    } else {
      return `$${value}`;
    }
  }

}
